/**
 * @file ProtectedRoute.tsx
 * @description Componente que protege rutas requiriendo autenticación
 * @author XiaVan Team
 */

import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { ReactNode } from 'react'

interface ProtectedRouteProps {
  children: ReactNode
}

/**
 * Wrapper que verifica autenticación antes de mostrar contenido
 * Si no está autenticado → redirige a /login
 * Si está autenticado pero no autorizado → redirige a /login
 */
export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isAuthorized, loading } = useAuth()

  // Mostrar loading mientras verifica autenticación
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-600 to-purple-700 flex items-center justify-center">
        <div className="text-white text-xl">Verificando acceso...</div>
      </div>
    )
  }

  // Si no hay usuario O no está autorizado → redirigir a login
  if (!user || !isAuthorized) {
    return <Navigate to="/login" replace />
  }

  // Usuario autenticado y autorizado → mostrar contenido
  return <>{children}</>
}
